import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { Subject, Observer, Observable } from 'rxjs';
import { componentFadeIn } from '../../route-animations';
import { IGridOptions, IPagingResult } from '@Workspace/interfaces';
import { Functions, Constants } from '@Workspace/common';
import { AccountController, CampaignController, TestController} from '@Workspace/_generated/services';
import { eCampaignStatus, eAccountType, eUserRole, eEntityStatus, eRegion, eChannelType, eApiBuildStatus, eFilterDefiniton, eBuildErrorType, eProductCategoryFan365, eProductCategoryOAS, eProductCategorySocial, eProductCategoryContent, eCreativeStatus, eCreativeStatusBuild, eStandardCampaginChannel, eStandardCampaginChannelName, ePerformanceGoalTypeMeta, eCampaignObjectiveTypeMeta, eCampaignObjectiveTypeMetaName, ePerformanceGoalTypeMetaName } from '@Workspace/_generated/enums';

import { PageLoaderService, SettingsService, StorageService } from '@Workspace/services';
import { IUserPropertiesDto, IAccountDto, IBaseCampaignDto, ICampaignBulkSettingsDto, ISeasonMappingDto, IPlatformBuildStatusJson, ICampaignErrorMessageDto, ICampaignInventoryItemDto, ICreativeDto } from '@Workspace/_generated/interfaces';
import { AuthService } from '@Workspace/auth';
import { CampaignService } from '../../services/campaign.service';
import { take, takeUntil,retry } from 'rxjs/operators';
import { CartItemService } from '../../../shared-core/components/card-item/card-item.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FileUploadService } from '../../services/file-upload.service';
import * as moment from 'moment';
import { QueryBuilder } from 'odata-query-builder';
import { GridComponent } from '../../../shared-core/components/grid/rc-grid.component';
import * as _ from 'lodash';
import { CampaignTransferDataDialog } from '../campaign-transfer-data-dialog/campaign-transfer-data-dialog';
import { ConfirmationService, MenuItem, MessageService, SelectItem } from 'primeng/api';
import { faCircleCheck, faCircleExclamation, faCircleXmark, faShareFromSquare, faClipboard } from '@fortawesome/free-solid-svg-icons';
import { MetaApiBuildDialog } from '../../../shared-core/components/meta-api-build-dialog/meta-api-build-dialog';
import { HsApiBuildDialog } from '../../../shared-core/components/hs-api-build-dailog/hs-api-build-dailog';

export interface ICampaignError{
    campaignId: string;
    isMessageExist: boolean;
    message: string;
}

@Component({
    selector: 'campaign-list-component',
    templateUrl: './campaign-list.component.html',
    styleUrls: ['./campaign-list.component.scss'],
    animations: [componentFadeIn]
})
export class CampaignListComponent implements OnInit, OnDestroy {

    constructor(
        public accountController: AccountController,
        public campaignController: CampaignController,
        public testController: TestController,
        public pageLoader: PageLoaderService,
        private settingsService: SettingsService,
        private campaignService: CampaignService,
        private messageService: MessageService,
        private router: ActivatedRoute,
        private route: Router,
        private authService: AuthService,
        private confirmationService: ConfirmationService,
        private storageService: StorageService
    ) {
    }
    @Input() status: SelectItem;
    @Input() gridId: number;
    @Input() options: IGridOptions;
    @Input() currentAccount: IAccountDto[];
    @Input() selectedSponsorInput: string = '';
    @Input() clientNameFilter: string = '';
    @Input() fiscalYearFilter: string[] = [];
    @Input() showCheckboxes: boolean = false;
    @Output() onAfterDataLoadList: EventEmitter<any> = new EventEmitter();
    @Output() selectedCampaignsEmmiter: EventEmitter<any> = new EventEmitter();
    @Output() updateBreadCrumb: EventEmitter<any> = new EventEmitter();
    @Output() applyFilters: EventEmitter<any> = new EventEmitter();
    @ViewChild(GridComponent) GridComponent: GridComponent;
    @ViewChild('campaignTransferDataDialog') campaignTransferDataDialog: CampaignTransferDataDialog;
    @ViewChild('metaApiBuildDialog') metaApiBuildDialog: MetaApiBuildDialog;
    @ViewChild('hsApiBuildDialog') hsApiBuildDialog: HsApiBuildDialog;
    
    loaded: boolean = false;
    constants = Constants;
    enumCampaignStatus = eCampaignStatus;
    enumAccountType = eAccountType;
    enumProductCategoryFan365 = eProductCategoryFan365;
    enumUserRole = eUserRole;
    enumEntityStatus = eEntityStatus;
    ngUnsubscribe = new Subject();
    currentUser: IUserPropertiesDto = this.authService.userSettings;
    searchParameter: string = '';
    searchParameterSponsor: string = '';
    grids: SelectItem[] = [];
    showGrid: boolean = true;
    enumCampaignRegion = eRegion;
    isCampaignLive: boolean;
    displayBasic: boolean = false;
    unlock: boolean = false;
    //options: IGridOptions;
    nameEllipsesState: { [id: string]: boolean } = {};
    selectedCampaigns: ICampaignBulkSettingsDto[] = [];
    isAllRowsChecked: boolean = false;
    campaignBulkSettings: ICampaignBulkSettingsDto;
    splitButtonMenu: MenuItem[];
    seasons: ISeasonMappingDto[];
    campaignErrorMessage: ICampaignError[] = [];

    skipParam: number = 0;
    takeParam: number = 10;
    sortOrder: number = 0;
    sortField: string = '';
    selectedSponsor: string = '';
    dealId: string = '';
    items: MenuItem[];
    gridList: any[] = [];

    faClipboard: any = faClipboard;
    faCircleCheck: any = faCircleCheck;
    faCircleXmark: any = faCircleXmark;
    faCircleExclamation: any = faCircleExclamation;
    faShareFromSquare: any = faShareFromSquare;
    numberOfFiscalYears: number;
    actionRequired: boolean= false;
    DV360creativeCheckBoxWarningTimeout: ReturnType<typeof setTimeout>;

    campaignsGroupedBySponsor = {} as IPagingResult;
    async ngOnInit() {       
        await this.campaignController.GetAllSeasonMapping().pipe(retry(2)).subscribe(data => {
            this.numberOfFiscalYears = new Set(data.map(opt => opt.seasonYear))?.size;
        });

        this.router.paramMap.subscribe(params => {
            if(params.get('sponsor')){
                this.selectedSponsorInput = params.get('sponsor');
                if(localStorage.getItem('sponsor') == null){
                    this.updateBreadCrumb.emit(params.get('sponsor'));
                }
            }
         })

         if(localStorage.getItem('sponsor') != null){
                this.selectedSponsorInput = localStorage.getItem('sponsor');
                this.updateBreadCrumb.emit(localStorage.getItem('sponsor'));
         }

        this.campaignService.getGridIdId().pipe(takeUntil(this.ngUnsubscribe)).subscribe(async x => {
            this.gridId = x;
            this.selectedSponsor = this.selectedSponsorInput;
            if(!!this.gridId){
                await this.GetSeasonYear();
                if(((this.currentUser.permissions.isLearfieldClient || this.currentUser.permissions.isOASClient || this.currentUser.permissions.isSocialClient) 
                    && this.currentUser.userRole != eUserRole.LFSocial && this.currentUser.userRole != eUserRole.AdOps && this.currentUser.userRole != eUserRole.LFSocial_Manager && this.currentUser.userRole != eUserRole.AdOps_Manager)  && !this.selectedSponsor){
                    if(localStorage.getItem('gridFilter') == null || localStorage.getItem('gridFilter') == "" || localStorage.getItem('gridFilter') == "null"){
                        await this.composeGroupedGrid();
                    }
                }
                else{
                    if(localStorage.getItem('gridFilter') == null || localStorage.getItem('gridFilter') == "" || localStorage.getItem('gridFilter') == "null"){
                        await this.composeGridColumns();
                    } 
                }
            }
        });
            //await this.composeFilter(); 
    }

    getMenuItemsForItem(rowData: IBaseCampaignDto) {
        if(!this.gridList.some(x=> x.campaignId == rowData.id)){
            this.splitButtonMenu = this.fillSplitButtonMenu(rowData);
            
            let showMenu = false;
            this.splitButtonMenu.forEach(v => {
                if (v.visible == true) {
                    showMenu = true;
                }
            });

            this.gridList.push({
                "campaignId": rowData.id, "isVisible": showMenu, "splitButtonMenu": this.splitButtonMenu
            });
            return [this.gridList.filter(x=>x.campaignId == rowData.id)[0].splitButtonMenu, this.gridList.filter(x=>x.campaignId == rowData.id)[0].isVisible]; // returns menuItem[] and property for visibility of menu icon 

        }
        else if(this.gridList.some(x=> x.campaignId == rowData.id && rowData.entityStatus == eEntityStatus.Transfered)){
            this.splitButtonMenu = this.fillSplitButtonMenu(rowData);

            let showMenu = false;
            this.splitButtonMenu.forEach(v => {
                if (v.visible == true) {
                    showMenu = true;
                }
            });
            this.gridList.filter(x=>x.campaignId == rowData.id).forEach(x=>{
                x.isVisible = showMenu;
                x.splitButtonMenu = this.splitButtonMenu;
            });
            return [this.gridList.filter(x=>x.campaignId == rowData.id)[0].splitButtonMenu, this.gridList.filter(x=>x.campaignId == rowData.id)[0].isVisible]; // returns menuItem[] and property for visibility of menu icon 
        }
        return [this.gridList.filter(x=>x.campaignId == rowData.id)[0].splitButtonMenu, this.gridList.filter(x=>x.campaignId == rowData.id)[0].isVisible];
      }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        
        if (this.DV360creativeCheckBoxWarningTimeout) {
            clearTimeout(this.DV360creativeCheckBoxWarningTimeout);
        }
    }
    handleEllipseAdded(ellipseState: boolean, id: string) {
        this.nameEllipsesState[id] = ellipseState;
    }
    checkIsCampaignLive(rowData: IBaseCampaignDto): boolean {
        if (rowData.campaignStatusId == eCampaignStatus.Campaign_Live)
            return true
        else
            return false
    }

    async composeGroupedGrid(clientName: string = ''){
        this.clientNameFilter = clientName != '' ? clientName : this.clientNameFilter;
        if(localStorage.getItem('gridFilter') != null && localStorage.getItem('gridFilter') != "" && localStorage.getItem('gridFilter') != "null"){
            var sessionValue = JSON.parse(localStorage.getItem('gridFilter'));
           
            if(sessionValue['searchParameterSponsor'])
            {
                this.searchParameterSponsor = sessionValue['searchParameterSponsor'];
            }
        }
       
        this.options = {} as IGridOptions;
        this.options.isOData = false;
        this.options.columns = [
            {
                label: 'Sponsor',
                value: 'sponsor',
                width: '23%'
            },
            {
                label: 'Deal Number',
                value: 'dealId',
            },
            {
                label: 'Season',
                value: 'seasonYear',
                width: '10%'
            },
            {
                label: 'Last Modified',
                value: 'lastModified',
            },
            {
                label: 'Season Impression',
                value: 'seasonImpression',
                width: '11%'
            },
            {
                label: 'Revenue',
                value: 'revenue',
            },
            {
                label: 'Pending Campaigns',
                value: 'pendingCampaigns',
            }
        ];

        this.pageLoader.showPageLoader();
        //await this.GetSeasonYear();
        this.campaignController.GetCampaignGroupedBySponsor(this.clientNameFilter, this.fiscalYearFilter.toString(), this.searchParameterSponsor, 'sponsor', 1, '', this.actionRequired, this.skipParam, this.takeParam).pipe(retry(2), take(1)).subscribe(
            result => {
                this.options.data = result;
                this.GridComponent.value = this.options.data;
                this.pageLoader.hidePageLoader();
            },
            error => {}
        );
    }

    async composeGridColumns(event?, isFromComposeFilter: boolean = false) {
        if (!!event)
            this.gridId = event;

            if(this.options == null || this.options == undefined){
                this.options = {} as IGridOptions;
            }

        if(this.currentUser.userRole == 1 && this.currentUser.accountId == null  
            && this.currentUser.permissions.isLearfieldClient == false && this.currentUser.permissions.isHMPClient == false 
            && this.currentUser.permissions.isHSClient == false && this.currentUser.permissions.isOASClient == false 
            && this.currentUser.permissions.isSocialClient == false && this.currentUser.permissions.isClient == false)
            {
                return; 
            }

        if (this.gridId == 1 || this.gridId == 4 || this.gridId == 5 || (this.gridId == 6 && this.currentUser.userRole != eUserRole.Trafficker_Agency))
        {
            this.options.columns = [
                {
                    label: '',
                    value: '',
                    width: '1%'
                },
                {
                    label: 'Name',
                    value: 'name',
                    width: '17%'
                },
                {
                    label: 'Property',
                    value: 'accountName',
                    width: '9%'
                },
                {
                    label: 'Deal Number',
                    value: 'dealName',
                    width: '10%'
                },
                {
                    label: 'Last Modified',
                    value: 'modifiedOn',
                    width: '10%'
                },
                {
                    label: 'Impressions',
                    value: 'impressions',
                    align: 'right',
                    width: '4%'
                },
                {
                    label: 'Inventory Items',
                    value: 'inventoryItemCount',
                    align: 'right',
                    width: '4%'
                },
                {
                    label: 'Category',
                    value: '',
                    width: '12%'
                },
                {
                    label: 'Region',
                    value: 'regionId',
                    width: '6%'
                },
                {
                    label: 'Status',
                    value: 'statusId',
                    width: '10%'
                },
                {
                    label: '',
                    value: '',
                    width: '1%'
                },
                {
                    label: 'Report',
                    value: '',
                    align: 'center',
                    width: '0%'
                },
                {
                    label: 'Action',
                    value: '',
                    align: 'right',
                    width: '5%'
                }
            ];
            if(this.gridId == 4 && !(this.currentUser.permissions.isClient && this.currentUser.userRole != eUserRole.LFSocial && this.currentUser.userRole != eUserRole.AdOps && this.currentUser.userRole != eUserRole.LFSocial_Manager && this.currentUser.userRole != eUserRole.AdOps_Manager)){
                this.options.columns.splice(11, 0, 
                    {
                        label: 'Trafficked',
                        value: 'trafficked',
                        width: '3%'
                    });
            }
            if(this.gridId == 6 && this.currentUser.userRole != eUserRole.Trafficker_Agency) 
            {
                this.options.columns.splice(3, 0, 
                    {
                        label: 'Campaign Type',
                        value: 'campaignType',
                        width: '10%'
                    });
            } else 
            {
                this.options.columns.splice(5, 0,  
                    {
                    label: 'Advertiser Created',
                    value: 'createdOn',
                    width: '13%'
                });
            }
        }
        else if (this.gridId == 2)
            this.options.columns = [
                {
                    label: 'Name',
                    value: 'name',
                    width: '18%'

                },
                {
                    label: 'Client Name',
                    value: 'accountName',
                    width: '18%'
                },
                {
                    label: 'Last Modified',
                    value: 'modifiedOn',
                    width: '18%'
                },
                {
                    label: 'Status',
                    value: 'statusId',
                    align: 'left',
                    width: '11%'
                },
                {
                    label: '',
                    value: '',
                    width: '15%',
                    align: 'start'
                },
                {
                    label: 'Report',
                    value: '',
                    align: 'start',
                    width: '3%'
                },
                {
                    label: 'Action',
                    value: '',
                    align: 'right',
                    width: '20%'
                }
                // {
                //     label: 'Live',
                //     value: '',
                //     align: 'right',
                //     width: '5%'
                // }
            ];

        else if (this.gridId == 6 && this.currentUser.userRole == eUserRole.Trafficker_Agency)
            this.options.columns = [
                {
                    label: 'Name',
                    value: 'name',
                    width: '15%'
                },
                {
                    label: 'Client Name',
                    value: 'accountName',
                    width: '15%'
                },
                {
                    label: 'Last Modified',
                    value: 'modifiedOn',
                    width: '20%'
                },
                {
                    label: 'Status',
                    value: 'statusId'
                },
                {
                    label: 'Report',
                    value: '',
                    align: 'center',

                },
                {
                    label: 'Action',
                    value: '',
                    align: 'right',
                    width: '5%'
                }
            ];
        else
            this.options.columns = [
                {
                    label: 'Name',
                    value: 'name',
                    width: '15%'
                },
                {
                    label: 'Client Name',
                    value: 'accountName',
                    width: '13%'
                },
                {
                    label: 'Last Modified',
                    value: 'modifiedOn',
                    width: '12%'
                },
                {
                    label: 'Total',
                    value: 'totalAmount',
                    align: 'left',
                    width: '15%'
                },
                {
                    label: 'Status',
                    value: 'statusId',
                    align: 'left',
                    width: '18%'
                },
                {
                    label: '',
                    value: '',
                    width: '20%',
                    align: 'left'
                },
                {
                    label: 'Report',
                    value: '',
                    align: 'right',
                    width: '1%'
                },
                {
                    label: 'Action',
                    value: '',
                    align: 'right',
                    width: '25%'
                }
            ];

        if (!!this.currentAccount) {

            if (this.gridId == 1 || this.gridId == 4 || this.gridId == 5 || this.gridId == 6) {
                if(this.gridId == 6)
                    this.options.columns.splice(2, 1);
                else
                    this.options.columns.splice(1, 1);

                this.options.columns.splice(6, 2);
            }
            else {
                this.options.columns.splice(1, 1);
            }
        }
        if (this.currentUser.permissions.isClient) {
            if (this.currentUser.permissions.isLearfieldClient || this.currentUser.permissions.isOASClient || this.currentUser.permissions.isSocialClient
                || this.currentUser.userRole == eUserRole.LFSocial || this.currentUser.userRole == eUserRole.AdOps
                || this.currentUser.userRole == eUserRole.LFSocial_Manager || this.currentUser.userRole == eUserRole.AdOps_Manager
            ) {
                this.options.columns.splice(this.options.columns.length - 1, 1);
            }
            else if (this.currentUser.permissions.isHSClient) {
                this.options.columns.splice(this.options.columns.length - 1, 1);
            }
        }
        if(this.currentUser.userRole == eUserRole.Trafficker_AdOps)
            this.options.columns.splice(this.options.columns.length - 1, 1);

        if(!isFromComposeFilter){
            await this.composeFilter(null, null, 0, 10, !!this.currentAccount && this.currentAccount.length == 1 ? this.currentAccount[0].id : null);
        }
        
        if(localStorage.getItem('gridFilter') == null || localStorage.getItem('gridFilter') == "" || localStorage.getItem('gridFilter') == "null")
        {
            Functions.composeGridOptions(
                this.options,
                'Name',
                this.settingsService.createApiUrl('Campaign/GetAllCampaigns'),
                false
            );
        }

        this.options = _.cloneDeep(this.options);
    }

    public checkData(event) {
        if (event.totalCount)
            this.showGrid = false;
    }

    public async composeFilter(searchParameter?: string, gridFilters?: string, skip?: number, take?: number, clientNameFilter?: string) {
        this.clientNameFilter = clientNameFilter != null ? clientNameFilter : this.clientNameFilter;
        if(!this.options){
           
            if(((this.currentUser.permissions.isLearfieldClient || this.currentUser.permissions.isOASClient || this.currentUser.permissions.isSocialClient) 
            && this.currentUser.userRole != eUserRole.LFSocial && this.currentUser.userRole != eUserRole.AdOps && this.currentUser.userRole != eUserRole.LFSocial_Manager && this.currentUser.userRole != eUserRole.AdOps_Manager)  && !this.selectedSponsor){
                    await this.composeGroupedGrid();
            }
            else{
                    await this.composeGridColumns(null, true);
            }
        }

        if(take){
            this.skipParam = skip;
            this.takeParam = take;
            this.GridComponent.resetSkipTake();
        }
        if (this.gridId == 1)
            this.options.filter = `CampaignType eq Learfield.Mogo_Fan365.Common.Enums.eAccountType'${eAccountType.FAN365}'`;
        else if (this.gridId == 2)
            this.options.filter = `Account/TypeId eq Learfield.Mogo_Fan365.Common.Enums.eAccountType'${eAccountType.HS}'`;
        else if (this.gridId == 4)
            this.options.filter = `CampaignType eq Learfield.Mogo_Fan365.Common.Enums.eAccountType'${eAccountType.OAS}'`;
        else if (this.gridId == 5) {
            this.options.filter = `CampaignType eq Learfield.Mogo_Fan365.Common.Enums.eAccountType'${eAccountType.Social}'`;
        }
        else if (this.gridId == 6){
            if(this.currentUser.userRole == eUserRole.LFSocial || this.currentUser.userRole == eUserRole.LFSocial_Manager
                || this.currentUser.userRole == eUserRole.AdOps || this.currentUser.userRole == eUserRole.AdOps_Manager)
                this.options.filter =
                    `CampaignType eq Learfield.Mogo_Fan365.Common.Enums.eAccountType'${eAccountType.Social}'`;
            else if(this.currentUser.userRole == eUserRole.Trafficker_Agency)
                this.options.filter = 
                    `(CampaignType eq Learfield.Mogo_Fan365.Common.Enums.eAccountType'${eAccountType.HS}'
                    or CampaignType eq Learfield.Mogo_Fan365.Common.Enums.eAccountType'${eAccountType.HMP}')`;
            else
                this.options.filter = `CampaignType ne Learfield.Mogo_Fan365.Common.Enums.eAccountType'${eAccountType.Content}'`;

        }
        // else if (this.gridId == 7) {
        //     this.options.filter = `CampaignType eq Learfield.Mogo_Fan365.Common.Enums.eAccountType'${eAccountType.Content}'`;
        // }
        else
            this.options.filter = `Account/TypeId eq Learfield.Mogo_Fan365.Common.Enums.eAccountType'${eAccountType.HMP}'`;


        if (!!this.status) {
            if (this.status.value == 1)
                this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : ' ') +
                    (this.currentUser.permissions.isClient ?
                        ` (CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Assets_Pending}' 
                        or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Assets_Declined}'
                        or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Creative_Swaps}'
                        or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Payment_Not_Received}')` :

                        ` (CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Assets_Uploaded}' 
                        or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Assets_Approved}' 
                        or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Creative_Swaps}'
                        or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Payment_Completed}' 
                        or 
                         (StatusId ne ${null}
                             and CampaignStatusId ne Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Live}' 
                             and CampaignStatusId ne Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Paused}'
                             and CampaignStatusId ne Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Ended}'
                             and CampaignStatusId ne Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Expired}') 
                         )`)

            else if (this.status.value == 2)
                this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : ' ') +
                    (this.currentUser.permissions.isClient ?
                        ` (CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Draft}' 
                or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Assets_Uploaded}' 
                or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Assets_Approved}' 
                or 
                 ((CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Live}' 
                 or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Paused}') 
                 and StatusId ne Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Sent_to_API_Build}'))` :

                        ` (CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Assets_Pending}'
                or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Assets_Declined}'
                or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Payment_Not_Received}' 
                or
                 ((CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Live}' 
                 or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Paused}') 
                 and StatusId ne Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Sent_to_API_Build}'))`
                    )

            else if (this.status.value == 3)
                this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : '') +
                    ` (CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Ended}' or CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Expired}')`;
            
            this.options.filter += ' Grouped View ';
        }
        
        // Ticket #103703: Update HUB Status Filter to Multi-Select - This filter part was duplicating for client users.
        // if (localStorage.getItem('gridFilter') != null && localStorage.getItem('gridFilter') != "" && localStorage.getItem('gridFilter') != "null" && this.currentUser.permissions.isClient){
        //     var sessionValue = JSON.parse(localStorage.getItem('gridFilter'));
           
        //     let campaignStatusFilter;

        //     if(sessionValue['campaignStatus'])
        //     {
        //         campaignStatusFilter = sessionValue['campaignStatus'];

        //         this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : ' ') +
        //         ` (CampaignStatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${campaignStatusFilter}'
        //         or (CampaignStatusId ne Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'14' and CampaignStatusId ne Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'8' and
        //             StatusId eq Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${campaignStatusFilter}'))`;
        //     }
        // }

        if (this.currentUser.permissions.isHSClient) {

            this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : ' ') +
                ` CampaignStatusId ne Learfield.Mogo_Fan365.Common.Enums.eCampaignStatus'${eCampaignStatus.Campaign_Draft}'`;
        }

        if (!!this.clientNameFilter && (gridFilters == null || !gridFilters.includes("Account/Id eq "))) {
            this.options.filter += (this.options.filter != null && this.options.filter != '' ? ` and ` : ` `);
            this.options.filter += ` Account/Id eq ${this.clientNameFilter}`;
        }

        if(this.fiscalYearFilter.length==0 && this.gridId != 2 && this.gridId !=3 && !(this.gridId == 6 && this.currentUser.userRole == eUserRole.Trafficker_Agency))
            await this.GetSeasonYear();
        
        if(!!this.selectedSponsor)
            this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : '' ) + ` (Sponsor eq '${Functions.replaceSpecialCharacters(this.selectedSponsor)}') `;

        if(!!this.dealId)
            this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : '') +  ` (DealId eq '${Functions.replaceSpecialCharacters(this.dealId)}') `;

        if (!!gridFilters && gridFilters != '')
            this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : '') + gridFilters;
        else if(this.gridId != 2 && this.gridId !=3 && !(this.gridId == 6 && this.currentUser.userRole == eUserRole.Trafficker_Agency))
            this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : '') + ` SeasonMapping/SeasonYear in ('${this.fiscalYearFilter.toString().split(',').join("','")}')`;

        if (this.gridId == 2 || this.gridId == 3 || (this.gridId == 6 && this.currentUser.userRole == eUserRole.Trafficker_Agency)) {
            if(this.fiscalYearFilter.length != 0 && this.numberOfFiscalYears != this.fiscalYearFilter.length){
                if (!this.seasons) {
                    await this.GetSeasonYear();
                }
                let seasons = this.seasons.filter(s => this.fiscalYearFilter.includes(s.seasonYear));
                seasons.sort((x, y) => new Date(x.startDate).getTime() - new Date(y.startDate).getTime());
                let years =  Object.values(seasons.reduce((result, item) => {
                    if (!result[item.seasonYear]) {
                        result[item.seasonYear] = [];
                    }
                    result[item.seasonYear].push(item); 
                    return result;
                }, {}));
                this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and' : ' ');
                years.map((y, i)=> {
                    this.options.filter += (i != 0 ? ' or ' : ' (') + `(StartDate ge ${Functions.formatDateToYYYYMMDD(new Date(y[0].startDate))}`;
                    this.options.filter += ' and' + ` StartDate le ${Functions.formatDateToYYYYMMDD(new Date(y[3].endDate))})`;
                    this.options.filter += ' or' + ` (EndDate ge ${Functions.formatDateToYYYYMMDD(new Date(y[0].startDate))}`;
                    this.options.filter += ' and' + ` EndDate le ${Functions.formatDateToYYYYMMDD(new Date(y[3].endDate))})`;
                    this.options.filter += ' or' + ` (StartDate le ${Functions.formatDateToYYYYMMDD(new Date(y[0].startDate))}`;
                    this.options.filter += ' and' + ` EndDate ge ${Functions.formatDateToYYYYMMDD(new Date(y[3].endDate))})`;
                })
                this.options.filter += (this.options.filter != null && this.options.filter != '' ? ')' : ' ');
            }
        }

            //this.searchParameter = searchParameter;
        if (!!searchParameter || !!this.searchParameter) {
            // const searchTerm = !!searchParameter ? searchParameter.replace(
            //     /\'/g,
            //     "''"
            // ) : this.searchParameter.replace(
            //     /\'/g,
            //     "''"
            // );
            const searchTerm = !!searchParameter ? searchParameter : this.searchParameter;

            if(this.gridId != eAccountType.HMP && this.gridId != eAccountType.HS){
                this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : ' ') +
                    ` (contains(Name, '${Functions.replaceSpecialCharacters(searchTerm)}') or contains(DealName, '${Functions.replaceSpecialCharacters(searchTerm)}')
                        or contains(PSSBroadcastContractLine/AccountNumber, '${Functions.replaceSpecialCharacters(searchTerm)}'))`;
            }
            else{
                this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : ' ') +
                    ` (contains(Name, '${Functions.replaceSpecialCharacters(searchTerm)}') or contains(DealName, '${Functions.replaceSpecialCharacters(searchTerm)}'))`;
            }

        }
        else
            this.options.filter += (this.options.filter != null && this.options.filter != '' ? ' and ' : ' ') +  ` contains(Name, '')`;

        let options = this.options;
        this.options = Object.assign({}, options);

        if(localStorage.getItem('gridFilter') != null && localStorage.getItem('gridFilter') != "" && localStorage.getItem('gridFilter') != "null")
        {    
            if(!((this.currentUser.permissions.isLearfieldClient || this.currentUser.permissions.isOASClient || this.currentUser.permissions.isSocialClient) && !this.selectedSponsor))
            {
                Functions.composeGridOptions(
                    this.options,
                    'Name',
                    this.settingsService.createApiUrl('Campaign/GetAllCampaigns'),
                    false
                );
            }
        }
    }

    async GetSeasonYear()
    {
        await this.campaignController.GetAllSeasonMapping().pipe(retry(2)).toPromise()
        .then(
            data=>{
                this.seasons = data;
                if(data.length>0){
                    data.forEach(x => {
                        let compareDate = moment(new Date());
                        let startDate   = moment(x.startDate);
                        let endDate     = moment(x.endDate);
        
                        if(compareDate.isBetween(startDate, endDate) && this.fiscalYearFilter.length == 0
                        && this.gridId != eAccountType.HS && this.gridId != eAccountType.HMP)
                            this.fiscalYearFilter=[x.seasonYear];
                    });
                }
            }
        );       
    }

    getCampaignChannels(campaign: IBaseCampaignDto) {
        let channels;
        let creativesSocial = campaign.creatives.some(x => x.channelId == eChannelType.Social);
        let creativesDisplay = campaign.creatives.some(x => x.channelId != eChannelType.Social);

        // if(campaign.entityStatus == eEntityStatus.Transfered){
        //     this.campaignController.GetTransferedCampaign(campaign.id).pipe(take(1)).subscribe(x =>{
        //         creativesSocial = x.data[0].creatives.some(x => x.channelId == eChannelType.Social);
        //         creativesDisplay = x.data[0].creatives.some(x => x.channelId != eChannelType.Social);
        //     });
        // }

        if (creativesSocial && creativesDisplay)
            channels = 'Display; Facebook';
        else if (creativesDisplay)
            channels = 'Display';
        else if (creativesSocial)
            channels = 'Facebook';
        else
            channels = '';

        return channels;
    }
    getTextAlignClass(textAlign: string): string {
        let textAlignClass: string = "text-left";
        switch (textAlign) {
            case 'left':
                textAlignClass = "text-left";
                break;
            case 'center':
                textAlignClass = "text-center";
                break;
            case 'right':
                textAlignClass = "text-right";
                break;
        }
        return textAlignClass;
    }

    navigateToReport(rowData: IBaseCampaignDto) {
        return "/#/campaign/" + rowData.id + "/reporting";
    }

    navigateToSponsor(rowData: IBaseCampaignDto){
        return "/#/fan365/" + rowData.sponsor.replace('/','%2F');
    }

    openEditDialog(rowData: IBaseCampaignDto, isHref: boolean = false) {
        if(!isHref){
            this.storageService.set("isEdit", true);
        }

        if (rowData.account.typeId == eAccountType.HMP)
            this.route.navigate(['/campaign/' + rowData.id]);
            //return "/#/campaign/" + rowData.id + "/";
        else if (rowData.account.typeId == eAccountType.HS)
            this.route.navigate(['/su-campaign/' + rowData.id]);
            //return "/#/su-campaign/" + rowData.id + "/";
    }
    editCampaign(rowData: IBaseCampaignDto) {
        this.displayBasic = true;
    }
    onChangeGrid(event) {
        this.gridId = event.value;
        this.composeGridColumns();
    }
    
    updateCampaignService(rowData: IBaseCampaignDto) {
        if(rowData.entityStatus == eEntityStatus.Transfered){
            return "/#";
        }
        else if (rowData.account.isLearfieldCampaign || rowData.account.isOASCampaign || rowData.account.isSocialCampaign)
            return "/#/campaign/" + rowData.id + "/campaign-upload-fan365";
        else if (rowData.account.isCampaignCreation && this.currentUser.permissions.isClient)
            return "/#/campaign/" + rowData.id;
        else 
            return "/#/campaign/" + rowData.id + "/campaign-upload";
    }

    openTransferedCampaignModal(event: Event, id: string){
        event.preventDefault();
        this.campaignController.GetTransferedCampaign(id).pipe(retry(2), take(1)).subscribe(x =>{
            if(x.data){
                this.confirmationService.confirm({
                    header: 'Campaign Transfered',
                    key: 'transferedCampaign',
                    message: 'This campaign has been transfered to <strong>' + x.data[0].name + '</strong>',
                    rejectVisible: true,
                    rejectLabel: 'Close',
                    acceptLabel: 'Open Target Campaign',
                    acceptButtonStyleClass: 'edge-button',
                    rejectButtonStyleClass: 'edge-no-button',
                    accept: async () => {
                        this.confirmationService.close();
                        setTimeout(() => {
                            if (x.data[0].account.isLearfieldCampaign || x.data[0].account.isOASCampaign || x.data[0].account.isSocialCampaign || x.data[0].account.isContentCampaign)
                                this.route.navigate(['/campaign/' + x.data[0].id + '/campaign-upload-fan365']);
                            else if (x.data[0].account.isCampaignCreation && this.currentUser.permissions.isClient)
                                this.route.navigate(['/campaign/' + x.data[0].id]);
                            else
                                this.route.navigate(['/campaign/' + x.data[0].id + '/campaign-upload']);
                        }, 500);
                    },
                    reject: () => {
                        this.confirmationService.close();
                    }
                });
            }
        })

    }

    // sendToApiBuild(rowData: IBaseCampaignDto, apiStatus: string) {
    //     this.confirmationService.confirm({
    //         header: 'Confirmation',
    //         key: 'changeStatus',
    //         message:
    //             'This action will initiate campaign API build. Do you want to continue?',
    //         rejectVisible: true,
    //         acceptLabel: 'Yes',
    //         rejectLabel: 'No',
    //         accept: async () => {
    //             let isDateDiff: boolean = false;
    //             if(rowData.failedCount > 0 && (rowData.campaignStatusId != eCampaignStatus.Campaign_Live && rowData.campaignStatusId != eCampaignStatus.Campaign_Paused)){
    //                 let newstartdate = moment(new Date(), 'YYYY-MM-DD 00:00:00').add(2, 'days');

    //                 if(newstartdate.diff(rowData.endDate) >= 0){
    //                     this.confirmationService.close();
    //                     this.messageService.add({ severity: 'error', detail: 'Start date is after end date!' });
    //                     isDateDiff = true;
    //                 } 
                    
    //                 else if(newstartdate.diff(rowData.startDate) >= 0){
    //                     rowData.startDate = newstartdate.utc().startOf('day').toDate();
    //                     if(new Date(rowData.creatives.find(x => x.creativeGroup == 1 && x.flightEndDate != null)?.flightEndDate) > rowData.startDate)
    //                         rowData.creatives.filter(x => x.creativeGroup == 1).forEach(x => {
    //                             x.flightStartDate = rowData.startDate;
    //                         });
    //                     else if(new Date(rowData.creatives.find(x => x.creativeGroup == 1 && x.flightEndDate != null)?.flightEndDate) <= rowData.startDate)
    //                     {
    //                         this.confirmationService.close();
    //                         this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Campaign start date is changed and set to start in next 2 days. Creative flight dates does not correspond to new Campaign start date. Please adjust creative flight dates and try again.', life: 5000 });
    //                         isDateDiff = true;
    //                     }
    //                 }
    //             }

    //             if(!isDateDiff){
    //                 rowData.statusId = eCampaignStatus.Sent_to_API_Build;
    //                 rowData.dspBuildIndicator = apiStatus;
    //                 this.pageLoader.showPageLoader();
    //                 this.campaignController.SaveCampaign(rowData).subscribe(
    //                     res => {
    //                         this.pageLoader.hidePageLoader();
    //                         this.composeGridColumns();
    //                         this.updateGrid();

    //                         if(res.statusId == rowData.statusId){
    //                             this.messageService.add({ severity: 'success', detail: 'Campaign is successfully sent to API build' });
    //                         }
    //                         else{
    //                             this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Campaign was not send to API build. Please try again.', life: 5000 });
    //                         }
                          
    //                         this.confirmationService.close();
    //                     },
    //                     err => {
    //                         this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Campaign was not send to API build. Status of campaign is not changed. Please try again.', life: 5000 });
    //                     }
                        
    //                 )
    //             }
                
    //         },
    //         reject: () => {
    //             this.confirmationService.close();
    //         }
    //     });
    // }

    initTraffickingGrid(rowData: IBaseCampaignDto) {
        this.confirmationService.confirm({
            header: 'Confirmation',
            key: 'initTrafficking',
            message:
                'This action will initiate trafficking grid. Do you want to continue?',
            rejectVisible: true,
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            acceptButtonStyleClass: 'edge-button',
            rejectButtonStyleClass: 'edge-no-button',
            accept: async () => {
                rowData.isTraffickingGridInitiated = true;
                this.pageLoader.showPageLoader();
                this.campaignController.SaveCampaign(rowData).subscribe(x => {
                    this.pageLoader.hidePageLoader();

                    this.composeGridColumns();

                    this.messageService.add({ severity: 'success', detail: 'Trafficking grid is successfully initiated' });
                    this.confirmationService.close();
                })
            },
            reject: () => {
                this.confirmationService.close();
            }
        });
    }

    changeStatus(rowData: IBaseCampaignDto) {
        this.confirmationService.confirm({
            header: 'Confirmation',
            key: 'pauseLiveCampaign',
            message:
                rowData.campaignStatusId == eCampaignStatus.Campaign_Live ? 'This action will pause campaign. Do you want to continue?' : 'This action will change campaign status to Live. Do you want to continue?',
            rejectVisible: true,
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            acceptButtonStyleClass: 'edge-button',
            rejectButtonStyleClass: 'edge-no-button',
            accept: async () => {
                rowData.statusId = rowData.campaignStatusId == eCampaignStatus.Live_365_Update ? eCampaignStatus.Live_365_Update : rowData.statusId;
                rowData.campaignStatusId = rowData.campaignStatusId == eCampaignStatus.Campaign_Live ? eCampaignStatus.Campaign_Paused : eCampaignStatus.Campaign_Live;
                this.pageLoader.showPageLoader();
                this.campaignController.SaveCampaign(rowData).subscribe( res => {

                    this.pageLoader.hidePageLoader();
                    this.composeGridColumns();
                    this.updateGrid();
                    if(res.campaignStatusId == rowData.campaignStatusId){
                        this.messageService.add({ severity: 'success', detail: rowData.campaignStatusId == eCampaignStatus.Campaign_Live ? 'Campaign is Live now' : 'Campaign is paused successfully' });
                    }
                    else {
                        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Status of campaign is not changed. Please try again.', life: 5000 });
                    }
                    this.confirmationService.close();


                },
                err => {
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Status of campaign is not changed. Please try again.', life: 5000 });
                })
            },
            reject: () => {
                this.confirmationService.close();
            }
        });
    }

    changeTrafficked(rowData: IBaseCampaignDto){
        this.campaignController.ChangeTraffickedFlag(rowData).subscribe(res =>{
            this.messageService.add({ severity: 'success', detail: 'Trafficked indicator is successfully changed' });
        });
    }

    getInventoryItemTooltip(rowData: IBaseCampaignDto) {
        let tooltipString = '';
        rowData.campaignInventoryItems.forEach(x => {
            tooltipString += (x.inventoryItem != null ? x.inventoryItem.name :
                (x.inventoryItemNew != null ? x.inventoryItemNew.name :
                    (x.inventoryItemOAS != null ? x.inventoryItemOAS.name : 
                        (x.inventoryItemSocial != null ? x.inventoryItemSocial.name : x.inventoryItemContent.name)))) + '\n'
        });
        return tooltipString;
    }

    remove(item) {
        this.confirmationService.confirm({
            header: 'Confirmation',
            key: 'campaignDelete',
            message:
                'Are you sure you want to delete Campaign?',
            rejectVisible: true,
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            acceptButtonStyleClass: 'edge-button',
            rejectButtonStyleClass: 'edge-no-button',
            accept: async () => {
                item.entityStatus = eEntityStatus.Deleted;
                this.campaignController.SaveCampaign(item).subscribe(x => {
                    this.composeGridColumns();
                    this.confirmationService.close();
                });
            },
            reject: () => {
                this.confirmationService.close();
            }
        });
    }

    checkRow(rowData, event){
        this.campaignBulkSettings = {} as ICampaignBulkSettingsDto;
            if (event.checked) {

                this.campaignBulkSettings.campaignId = rowData.id;
                this.campaignBulkSettings.dealId = rowData.dealId;
                this.campaignBulkSettings.regionId = rowData.regionId;

                this.selectedCampaigns.push(this.campaignBulkSettings);
            } else {
                this.selectedCampaigns = this.selectedCampaigns.filter(
                    item => item.campaignId != rowData.id
                );
            }

        this.selectedCampaignsEmmiter.emit({selectedCampaigns: this.selectedCampaigns, isAllRowsChecked: this.isAllRowsChecked});
    }

    async checkAllRows(event){
      this.isAllRowsChecked = event.checked;  
      if(event.checked){
        let options = this.options;

        options.select = ['Id', 'RegionId', 'DealId', 'CampaignJson', 'DV360AdvertiserId', 'TTDAdvertiserId'];

        let param = this.composeODataQuery(options);
        this.campaignController
            .GetAllCampaigns(param)
            .pipe(retry(2))
            .subscribe(x => {
                x.data.forEach(element => {
                    this.campaignBulkSettings = {} as ICampaignBulkSettingsDto;
                    this.campaignBulkSettings.campaignId = element.id;
                    this.campaignBulkSettings.dealId = element.dealId;
                    this.campaignBulkSettings.regionId = element.regionId;                   
                    this.selectedCampaigns.push(this.campaignBulkSettings);
                });
            },
            error => {
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error.error.text });
            });
      }
      else{
          this.selectedCampaigns = [];
      }
      this.selectedCampaignsEmmiter.emit({selectedCampaigns: this.selectedCampaigns, isAllRowsChecked: this.isAllRowsChecked});

    }

    checkValue(rowData){
        if(this.isAllRowsChecked){
            return true;
        }
        else{
            if (this.selectedCampaigns.find(x => x.campaignId == rowData.id))
            return true;
        else
            return false;
        }
    }

    composeODataQuery(options) {
        const queryBuilder = new QueryBuilder()

        if (!!options.filter) {
            if (typeof options.filter === 'string') {
                const filterComposition = options.filter;

                queryBuilder.filter(filter =>
                    filter.filterPhrase(filterComposition)
                );
            } else if (
                typeof options.filter !== 'string' &&
                options.filter.definition === eFilterDefiniton.Equals
            ) {
                const filterComposition = options.filter;

                queryBuilder.filter(filter =>
                    filter.filterExpression(
                        filterComposition.field,
                        'eq',
                        filterComposition.value
                    )
                );
            } else if (
                typeof options.filter !== 'string' &&
                options.filter.definition === eFilterDefiniton.Contains
            ) {
                const filterComposition = options.filter;

                queryBuilder.filter(filter =>
                    filter.filterPhrase(
                        `contains(${filterComposition.field}, '${
                        filterComposition.value
                        }')`
                    )
                );
            }

            queryBuilder.select(options.select);

            return queryBuilder.toQuery();
        }
    }

    resetSelectedCampaign(){
        this.selectedCampaigns = [];
    }

    setParameters(event){
            this.sortField = event.sortField === undefined ? '' : event.sortField;
            this.sortOrder = event.sortOrder === undefined ? '' : event.sortOrder;
            this.skipParam = event.skip;
            this.takeParam = event.take;
            this.pageLoader.showPageLoader();
    
            this.campaignController.GetCampaignGroupedBySponsor(this.clientNameFilter ? this.clientNameFilter : this.currentAccount[0].id, this.fiscalYearFilter.toString(), this.searchParameterSponsor, this.sortField, this.sortOrder, '', this.actionRequired, this.skipParam, this.takeParam).pipe(retry(2), take(1)).subscribe(
                result => {
                    this.options.data = result;
                    this.GridComponent.value = this.options.data;
                    this.pageLoader.hidePageLoader();
                },
                error => {}
            );
    }

    searchGroupedCampaigns(event){
            this.searchParameterSponsor = event;
    
            this.campaignController.GetCampaignGroupedBySponsor(this.clientNameFilter ? this.clientNameFilter : this.currentAccount[0].id, this.fiscalYearFilter.toString(), event, this.sortField, this.sortOrder, '', this.actionRequired, 0, this.takeParam).pipe(retry(2), take(1)).subscribe(
                result => {
                    this.options.data = result;
                    this.GridComponent.value = this.options.data;
                    this.GridComponent.setPage(0);
                    this.pageLoader.hidePageLoader();
                },
                error => {}
            );
    }

    setSponsor(sponsor, dealId, event: Event){
        event.preventDefault();
        this.selectedSponsor = sponsor;
        localStorage.setItem('sponsor', sponsor);
        this.dealId = dealId;
        this.updateBreadCrumb.emit(sponsor);
        this.composeGridColumns();
    }

    resetGroupedCampaigns(){
        let url: string = this.route.url.substring(0, this.route.url.indexOf("fan365/"));
        this.route.navigateByUrl(url);

        localStorage.removeItem('sponsor');
        this.selectedSponsor = '';
        this.dealId = '';
        this.updateBreadCrumb.emit('');
        this.composeGroupedGrid();
    }

    transferData(rowData: IBaseCampaignDto){
        this.campaignTransferDataDialog.openDialog(rowData);
    }

    fillSplitButtonMenu(rowData: IBaseCampaignDto){
        let latestApiReporting = rowData.apiReportings?.[0];
        const apiBuildChannels = [
            eStandardCampaginChannel.Standard_Display_Banner,
            eStandardCampaginChannel.Abandoned_Cart_Display_Banner,
            eStandardCampaginChannel.Post_Purchase_Upsell_Display_Banner,
            eStandardCampaginChannel.Premium_Display_Banner,
            eStandardCampaginChannel.Native_Image,
            eStandardCampaginChannel.Native_Video,
            eStandardCampaginChannel.ConnectedTv,
            eStandardCampaginChannel.In_Stream_Video,
            eStandardCampaginChannel.Streaming_Audio
        ];

        const apiHSBuildChannels = [
            eStandardCampaginChannel.Standard_Display_Banner,
            eStandardCampaginChannel.Abandoned_Cart_Display_Banner,
            eStandardCampaginChannel.Post_Purchase_Upsell_Display_Banner,
            eStandardCampaginChannel.Premium_Display_Banner,
            eStandardCampaginChannel.Native_Image,
            eStandardCampaginChannel.Native_Video,
            eStandardCampaginChannel.ConnectedTv,
            eStandardCampaginChannel.In_Stream_Video
        ];
        
        const isLive365ImpressionUpdateAfterApprovedStatus =
            (rowData.campaignStatusId == this.enumCampaignStatus.Live365_Impression_Update && latestApiReporting?.campaignStatusIdNew == this.enumCampaignStatus.Live365_Impression_Update && latestApiReporting?.campaignStatusIdOld == this.enumCampaignStatus.Assets_Approved)
            || (rowData.statusId == this.enumCampaignStatus.Live365_Impression_Update && latestApiReporting?.statusIdNew == this.enumCampaignStatus.Live365_Impression_Update && latestApiReporting?.statusIdOld == this.enumCampaignStatus.Assets_Approved);

        const ttdTooltip = this.getApiBuildMenuTooltip(rowData, apiHSBuildChannels);
        const dv360Tooltip = this.getApiBuildMenuTooltip(rowData, apiHSBuildChannels);
        this.splitButtonMenu = [
            {
                label: 'Edit', 
                icon: 'fa fa-edit',
                command: () => this.openEditDialog(rowData),
                visible: ((this.gridId == 2 || this.gridId == 3) 
                    && (this.currentUser.permissions.canCreateCampaignEmployee || this.currentUser.permissions.canCreateCampaignClient) 
                    && ((rowData.campaignStatusId == this.enumCampaignStatus.Campaign_Draft && rowData.statusId == null) 
                        || (this.gridId == 2 && (this.currentUser.userRole == this.enumUserRole.Client_Solution || this.currentUser.userRole == this.enumUserRole.EDGE_Manager || this.currentUser.userRole == this.enumUserRole.Admin || this.currentUser.userRole == this.enumUserRole.Trafficker_Agency) 
                            && rowData.statusId == null))
                )
            },
            {
                label: 'Remove', 
                icon: 'fa fa-trash',
                command: () => this.remove(rowData),
                visible: ((this.gridId == 2 || this.gridId == 3) 
                    && (rowData.campaignStatusId == this.enumCampaignStatus.Campaign_Draft || rowData.campaignStatusId == this.enumCampaignStatus.Assets_Pending) 
                    && rowData.statusId == null 
                    && (this.currentUser.userRole == this.enumUserRole.Client_Solution || this.currentUser.userRole == this.enumUserRole.EDGE_Manager || this.currentUser.userRole == this.enumUserRole.Admin || this.currentUser.userRole == this.enumUserRole.Trafficker_Agency))
            },
            {
                label: 'Trafficking grid',
                icon: 'fa fa-paper-plane fa-lg',
                command: () => this.initTraffickingGrid(rowData),
                visible: (this.gridId == 2 && (this.currentUser.userRole == this.enumUserRole.Client_Solution || this.currentUser.userRole == this.enumUserRole.EDGE_Manager || this.currentUser.userRole == this.enumUserRole.Associate || this.currentUser.userRole == this.enumUserRole.Admin || this.currentUser.userRole == this.enumUserRole.Trafficker_Agency)) 
                || ((this.gridId == 3 && rowData.campaignStatusId != this.enumCampaignStatus.Assets_Pending && rowData.campaignStatusId != this.enumCampaignStatus.Campaign_Draft 
                    && (this.currentUser.userRole == this.enumUserRole.Client_Solution || this.currentUser.userRole == this.enumUserRole.EDGE_Manager || this.currentUser.userRole == this.enumUserRole.Associate || this.currentUser.userRole == this.enumUserRole.Admin || this.currentUser.userRole == this.enumUserRole.Trafficker_Agency))),
                disabled : this.gridId == 2 && !(rowData.campaignStatusId != this.enumCampaignStatus.Assets_Pending && rowData.campaignStatusId != this.enumCampaignStatus.Campaign_Draft)
            },
            {
                label: 'Go Live', 
                icon: 'fa fa-paper-plane',
                command: () => this.changeStatus(rowData),
                visible: (rowData.statusId == this.enumCampaignStatus.Sent_to_API_Build || rowData.statusId == this.enumCampaignStatus.Build_Success) && (this.currentUser.userRole == this.enumUserRole.Media_Activation || this.currentUser.userRole == this.enumUserRole.Media_Activation_Manager || this.currentUser.userRole == this.enumUserRole.Admin)
            },
            {
                label: 'Transfer Data', 
                icon: 'fa fa-retweet',
                command: () => this.transferData(rowData),
                visible: (rowData.campaignType == eAccountType.OAS || rowData.campaignType == eAccountType.FAN365) && (rowData.campaignStatusId == this.enumCampaignStatus.Live_365_Update 
                || rowData.statusId == this.enumCampaignStatus.Live_365_Update 
                || (rowData.campaignStatusId == this.enumCampaignStatus.Campaign_Ended && latestApiReporting?.campaignStatusIdNew == this.enumCampaignStatus.Campaign_Ended && latestApiReporting?.campaignStatusIdOld == this.enumCampaignStatus.Live_365_Update))
                && rowData.entityStatus == eEntityStatus.Active
                && (!this.currentUser.permissions.isClient || this.currentUser.userRole == this.enumUserRole.AdOps || this.currentUser.userRole == this.enumUserRole.AdOps_Manager || this.currentUser.userRole == this.enumUserRole.LFSocial || this.currentUser.userRole == this.enumUserRole.LFSocial_Manager || this.currentUser.userRole == this.enumUserRole.Associate)
            },
            {
                label: 'Send to API - TTD',
                icon: 'ttd-icon',
                command: () => this.sendToApiIntegrationBuild(rowData,"TTD"),
                visible: (rowData.campaignType == eAccountType.HS && (this.currentUser.userRole == this.enumUserRole.Media_Activation || this.currentUser.userRole == this.enumUserRole.Media_Activation_Manager || this.currentUser.userRole == this.enumUserRole.Admin || this.currentUser.userRole == this.enumUserRole.Client_Solution || this.currentUser.userRole == this.enumUserRole.EDGE_Manager || this.currentUser.userRole == this.enumUserRole.Trafficker_Agency || this.currentUser.userRole == this.enumUserRole.Associate)
                        && (rowData.dspBuildIndicator == null || rowData.dspBuildIndicator == "TTD") && this.isHSChannel(rowData.creatives, apiHSBuildChannels)) 
                || (!rowData.account.automaticApiBuild 
                    //&& rowData.creatives.some(x => (x.channelId == eChannelType.Display || x.channelId == eChannelType.Other) && x.creativeAssets.some(a => a.isValid == true))
                    //&& rowData.campaignType == eAccountType.FAN365
                   &&  this.isChannelReadyForBuild(rowData.creatives, apiBuildChannels, rowData.platformBuildStatusJson,"TTD") 
                    && (rowData.campaignType == eAccountType.FAN365 || rowData.campaignType == eAccountType.HMP)
                    && (rowData.campaignStatusId == this.enumCampaignStatus.Assets_Approved || rowData.statusId == this.enumCampaignStatus.Assets_Approved || isLive365ImpressionUpdateAfterApprovedStatus)
                    && rowData.statusId != this.enumCampaignStatus.Sent_to_API_Build
                    && (this.currentUser.userRole == this.enumUserRole.Media_Activation || this.currentUser.userRole == this.enumUserRole.Media_Activation_Manager || this.currentUser.userRole == this.enumUserRole.Admin || this.currentUser.userRole == this.enumUserRole.Client_Solution || this.currentUser.userRole == this.enumUserRole.EDGE_Manager || this.currentUser.userRole == this.enumUserRole.Trafficker_Agency || this.currentUser.userRole == this.enumUserRole.Associate)
                    && (rowData.dspBuildIndicator == null || rowData.dspBuildIndicator == "TTD")),
                disabled: rowData.campaignType == eAccountType.HS && !((rowData.campaignStatusId == this.enumCampaignStatus.Assets_Approved || rowData.statusId == this.enumCampaignStatus.Assets_Approved) 
                && rowData.statusId != this.enumCampaignStatus.Sent_to_API_Build
                && this.isChannelReadyForBuild(rowData.creatives, apiHSBuildChannels, rowData.platformBuildStatusJson,"TTD")),
                tooltip: ttdTooltip,
                tooltipOptions: {
                    tooltipLabel: ttdTooltip,
                    tooltipPosition: 'left',
                    tooltipStyleClass: 'campaign-action-tooltip',
                    showDelay: 150,
                    disabled: !ttdTooltip
                }
            },
            {
                label: 'Send to API - DV360',
                icon: 'dv360-icon',
                command: () => this.sendToApiIntegrationBuild(rowData,"DV360"),
                visible: (rowData.campaignType == eAccountType.HS && (this.currentUser.userRole == this.enumUserRole.Media_Activation || this.currentUser.userRole == this.enumUserRole.Media_Activation_Manager || this.currentUser.userRole == this.enumUserRole.Admin || this.currentUser.userRole == this.enumUserRole.Client_Solution || this.currentUser.userRole == this.enumUserRole.EDGE_Manager || this.currentUser.userRole == this.enumUserRole.Trafficker_Agency || this.currentUser.userRole == this.enumUserRole.Associate)
                    && (rowData.dspBuildIndicator == null || rowData.dspBuildIndicator == "DV360") && this.isHSChannel(rowData.creatives, apiHSBuildChannels)) 
                || (!rowData.account.automaticApiBuild
                    //&& rowData.creatives.some(x => (x.channelId == eChannelType.Display || x.channelId == eChannelType.Other) && x.creativeAssets.some(a => a.isValid == true)) 
                    //&& rowData.campaignType == eAccountType.FAN365
                   &&  this.isChannelReadyForBuild(rowData.creatives, apiBuildChannels, rowData.platformBuildStatusJson,"DV360") 
                    && (rowData.campaignType == eAccountType.FAN365 || rowData.campaignType == eAccountType.HMP) 
                    && (rowData.campaignStatusId == this.enumCampaignStatus.Assets_Approved || rowData.statusId == this.enumCampaignStatus.Assets_Approved || isLive365ImpressionUpdateAfterApprovedStatus)
                    && rowData.statusId != this.enumCampaignStatus.Sent_to_API_Build
                    && (this.currentUser.userRole == this.enumUserRole.Media_Activation || this.currentUser.userRole == this.enumUserRole.Media_Activation_Manager || this.currentUser.userRole == this.enumUserRole.Admin || this.currentUser.userRole == this.enumUserRole.Client_Solution || this.currentUser.userRole == this.enumUserRole.EDGE_Manager || this.currentUser.userRole == this.enumUserRole.Trafficker_Agency || this.currentUser.userRole == this.enumUserRole.Associate)
                    && (rowData.dspBuildIndicator == null || rowData.dspBuildIndicator == "DV360")
                    && (rowData.campaignInventoryItems[0]?.inventoryItemNew?.productCategory !=  eProductCategoryFan365.Audio)),
                    disabled : rowData.campaignType == eAccountType.HS && !((rowData.campaignStatusId == this.enumCampaignStatus.Assets_Approved || rowData.statusId == this.enumCampaignStatus.Assets_Approved) 
                    && rowData.statusId != this.enumCampaignStatus.Sent_to_API_Build
                    && this.isChannelReadyForBuild(rowData.creatives, apiHSBuildChannels, rowData.platformBuildStatusJson,"DV360")),
                    tooltip: dv360Tooltip,
                    tooltipOptions: {
                        tooltipLabel: dv360Tooltip,
                        tooltipPosition: 'left',
                        tooltipStyleClass: 'campaign-action-tooltip',
                        showDelay: 150,
                        disabled: !dv360Tooltip
                    }
            },
            {
                label: 'Send to API - META',
                icon: 'dv360-icon',
                command: () => this.sendToMetaApiBuild(rowData),
                visible: !rowData.account.automaticApiBuild
                    //&& rowData.creatives.some(x => (x.channelId == eChannelType.Social) && x.creativeAssets.some(a => a.isValid == true)) 
                    &&  this.isChannelReadyForBuild(rowData.creatives,
                            [
                            eStandardCampaginChannel.Facebook_Static_News_Feed,
                            eStandardCampaginChannel.Facebook_Dynamic_News_Feed,
                            eStandardCampaginChannel.Facebook_Dynamic_News_Feed_Video,
                            eStandardCampaginChannel.Facebook_News_Feed_Carousel,
                            eStandardCampaginChannel.Facebook_Static_News_Feed_Video,
                            eStandardCampaginChannel.Paid_support,
                            eStandardCampaginChannel.Content,
                            eStandardCampaginChannel.Snap_AR,
                            eStandardCampaginChannel.Social_Lead_Generation,
                            eStandardCampaginChannel.Social_Lead_Generation_Premium,
                            eStandardCampaginChannel.Digital_Game],rowData.platformBuildStatusJson,"META")
                    && (rowData.campaignType == eAccountType.FAN365 || rowData.campaignType == eAccountType.HMP) 
                    && (rowData.campaignStatusId == this.enumCampaignStatus.Assets_Approved || rowData.statusId == this.enumCampaignStatus.Assets_Approved|| isLive365ImpressionUpdateAfterApprovedStatus)
                    && rowData.statusId != this.enumCampaignStatus.Sent_to_API_Build
                    && (this.currentUser.userRole == this.enumUserRole.Media_Activation || this.currentUser.userRole == this.enumUserRole.Media_Activation_Manager || this.currentUser.userRole == this.enumUserRole.Admin || this.currentUser.userRole == this.enumUserRole.Client_Solution || this.currentUser.userRole == this.enumUserRole.EDGE_Manager || this.currentUser.userRole == this.enumUserRole.Trafficker_Agency)
                    // && (rowData.dspBuildIndicator == null || rowData.dspBuildIndicator == "META")
            },
            {
                label: 'Send to API',
                icon: 'dv360-icon',
                command: () => this.autoBuildGAMCampaign(rowData.id, true, eAccountType.OAS, rowData.name,false,rowData.campaignJSON, rowData.platformBuildStatusJson),
                visible: (rowData.campaignType == eAccountType.OAS) 
                    && (rowData.statusId == this.enumCampaignStatus.Build_Failed || rowData.statusId == this.enumCampaignStatus.Build_Partial_Success)
                    && (this.currentUser.userRole == this.enumUserRole.Admin || this.currentUser.userRole == this.enumUserRole.Client_Solution || this.currentUser.userRole == this.enumUserRole.EDGE_Manager)
            }
        ];
        return this.splitButtonMenu;
    }

    updateGrid(){
        this.applyFilters.emit();
        this.gridList = [];
    }

    //Build API Campaign
    async BuildAllCampaignsInBackground(baseCampaignId: string, campaignType: eAccountType, isCampaignBuildTriggeredFromUI: boolean, DSPIndicator: string, campaignName: string,isAutomaticCampaignBuild: boolean) {
        return new Promise<string>((resolve, reject) => {
            this.campaignController.BuildAllPlatformsInBackground(baseCampaignId, campaignType, isCampaignBuildTriggeredFromUI, DSPIndicator, campaignName,isAutomaticCampaignBuild).subscribe();
        });
    }
   

    //Method to send Campaign build messages email
    sendCampaignEmail(campaignMessages: string[], campaignName: string, campaignId, campaignType: eAccountType, DV360BuildStatusId: eCampaignStatus) {
        //this.pageLoader.showPageLoader();
        return new Promise<boolean>((resolve, reject) => {

            let content = {
                campaignId: campaignId,
                campaignName: campaignName,
                campaignMessage: campaignMessages,
                campaignType : campaignType,
                dV360BuildStatusId : DV360BuildStatusId
            };
            this.campaignController.SendCampaignBuildEmail(content).subscribe(
                (val: any) => {
                    //this.pageLoader.hidePageLoader();
                    resolve(val);
                },
                (error) => {
                    resolve(error);
                    //this.pageLoader.hidePageLoader();
                }
            );
        });
        
    }

    MetaCreateAdvertiser(rowData: IBaseCampaignDto){
        var campaignId = rowData.id;
        this.campaignController.BuildMetaAdvertiser(campaignId).subscribe(
            (val) => {
                //console.log(val);
                // let message = '';
                // for (let i = 0; i < val.length; i++) {
                //     message += `${i + 1}. ${val[i]}\n`;
                // }
                alert(val);
            });
    }

    MetaCreateCampaign(rowData: IBaseCampaignDto, isCampaignBuildTriggeredFromUI:boolean){
        var campaignId = rowData.id;
        this.campaignController.BuildMetaCampaign(campaignId,isCampaignBuildTriggeredFromUI).subscribe(
            async (val: string[]) => {
                this.pageLoader.hidePageLoader();
                if (Array.isArray(val)) {
                    const message = val.join('\n');
                    let campaignMessages: string[] = [];
                    campaignMessages.push(message);
                    await this.sendCampaignEmail(campaignMessages, rowData.name, rowData.id,rowData.campaignType,rowData.platformBuildStatusJson?.dV360BuildStatusId);

                    const formatMessage = (message: string) =>
                        message.split('\n').filter(line => line.trim() !== '').map(line => `• ${line}`).join('\n');

                    const formattedMetaMessage = formatMessage(message);
                    alert('Meta:\n ' + formattedMetaMessage);
                }
            }       
        );
    }

    MetaAssociateUserToPage(){
        this.campaignController.AssociateUserToPage().subscribe(
            (val) => {
                alert(val);
            },
            );
    }

    sendToApiIntegrationBuild(rowData: IBaseCampaignDto, buildProcess : string = null){
        if(rowData.campaignType == eAccountType.HS){
            this.hsApiBuildDialog.openDialog(rowData, buildProcess);
            return;
        }

        //Check if campaign build is already outside of HUB
        if (rowData.campaignJSON != null && rowData.platformBuildStatusJson == null) {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Campaign has been already built outside of the HUB. You can’t send this campaign to API build.', life: 5000 });
            return;
        }

        this.confirmationService.confirm({
            header: 'Confirmation',
            key: 'changeStatus',
            message:
                'This action will initiate campaign API build. Do you want to continue?',
            rejectVisible: true,
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            acceptButtonStyleClass: 'edge-button',
            rejectButtonStyleClass: 'edge-no-button',
            accept: async () => {
                let isDateDiff: boolean = false;
                if(rowData.failedCount > 0 && (rowData.campaignStatusId != eCampaignStatus.Campaign_Live && rowData.campaignStatusId != eCampaignStatus.Campaign_Paused)){
                    let newstartdate = moment(new Date(), 'YYYY-MM-DD 00:00:00').add(2, 'days');
                    if(newstartdate.diff(rowData.endDate) >= 0){
                        this.confirmationService.close();
                        this.messageService.add({ severity: 'error', detail: 'Start date is after end date!' });
                        isDateDiff = true;
                    } 

                    else if(newstartdate.diff(rowData.startDate) >= 0){
                        rowData.startDate = newstartdate.utc().startOf('day').toDate();
                        if(new Date(rowData.creatives.find(x => x.creativeGroup == 1 && x.flightEndDate != null)?.flightEndDate) > rowData.startDate)
                            rowData.creatives.filter(x => x.creativeGroup == 1).forEach(x => {
                                x.flightStartDate = rowData.startDate;
                            });
                        else if(new Date(rowData.creatives.find(x => x.creativeGroup == 1 && x.flightEndDate != null)?.flightEndDate) <= rowData.startDate)
                        {
                            this.confirmationService.close();
                            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Campaign start date is changed and set to start in next 2 days. Creative flight dates does not correspond to new Campaign start date. Please adjust creative flight dates and try again.', life: 5000 });
                            isDateDiff = true;
                        }
                    }
                }

                if(!isDateDiff){
                    rowData.statusId = eCampaignStatus.Sent_to_API_Build;
                    rowData.dspBuildIndicator = buildProcess;

                    //Set creative status to Sent to API if creative assets are present
                    if(rowData.campaignType == eAccountType.FAN365 || rowData.campaignType == eAccountType.HS || rowData.campaignType == eAccountType.HMP){
                        rowData.creatives
                            .filter(cr =>
                                cr.creativeTypeId === eStandardCampaginChannel.Standard_Display_Banner ||
                                cr.creativeTypeId === eStandardCampaginChannel.Abandoned_Cart_Display_Banner ||
                                cr.creativeTypeId === eStandardCampaginChannel.Post_Purchase_Upsell_Display_Banner ||
                                cr.creativeTypeId === eStandardCampaginChannel.Premium_Display_Banner ||
                                cr.creativeTypeId === eStandardCampaginChannel.Native_Image ||
                                cr.creativeTypeId === eStandardCampaginChannel.Native_Video ||
                                cr.creativeTypeId === eStandardCampaginChannel.ConnectedTv ||
                                cr.creativeTypeId === eStandardCampaginChannel.In_Stream_Video ||
                                cr.creativeTypeId === eStandardCampaginChannel.Streaming_Audio
                            )
                            .forEach(cr => {
                                if (cr.creativeAssets.some(ca => ca.file) && cr.creativeAssets.filter(ca => ca.file != null).every(ca => ca.isValid === true)) {
                                    cr.creativeStatusBuildId = eCreativeStatusBuild.Send_to_API;
                                }
                            });
                    }                    

                    this.pageLoader.showPageLoader();
                    this.campaignController.SaveCampaign(rowData).subscribe(
                        async res => {
                            
                            this.composeGridColumns();
                            this.updateGrid();

                            if(res.statusId == rowData.statusId){
                                this.messageService.add({ severity: 'success', detail: 'Campaign is successfully sent to API build' });
                            }
                            else{
                                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Campaign was not send to API build. Please try again.', life: 5000 });
                            }
                            
                            this.confirmationService.close();
                            this.pageLoader.hidePageLoader();
                            if(res.statusId == rowData.statusId){
                                if(rowData.campaignType == eAccountType.FAN365){
                                    this.pageLoader.hidePageLoader();
                                    this.showCreativeTypeWarningDialog();
                                }
                                await this.BuildAllCampaignsInBackground(rowData.id, rowData.campaignType, true, buildProcess, rowData.name,false);
                            }
                        },
                        err => {
                            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Campaign was not send to API build. Status of campaign is not changed. Please try again.', life: 5000 });
                        },
                    )
                }
                
            },
            reject: () => {
                this.confirmationService.close();
                this.pageLoader.hidePageLoader();
            }
        });
    }

    sendToMetaApiBuild(rowData: IBaseCampaignDto){
        this.metaApiBuildDialog.openDialog(rowData);
    }

    getBuildStatusesTooltip(rowData: IBaseCampaignDto) {
        let platformBuildStatusJson: IPlatformBuildStatusJson = rowData.platformBuildStatusJson;
        if(platformBuildStatusJson == null)
            return;

        if(platformBuildStatusJson.dV360BuildStatusId == eCampaignStatus.Build_Failed || platformBuildStatusJson.gcmBuildStatusId == eCampaignStatus.Build_Failed
        || platformBuildStatusJson.gamBuildStatusId == eCampaignStatus.Build_Failed || platformBuildStatusJson.ttdBuildStatusId == eCampaignStatus.Build_Failed
        || platformBuildStatusJson.metaBuildStatusId == eCampaignStatus.Build_Failed)
        {
            let tooltipString = '';

            if (!!platformBuildStatusJson.gcmBuildStatusId) {
                let buildStatus: string = platformBuildStatusJson.gcmBuildStatusId == eCampaignStatus.Build_Failed ? 'Build Failed' : 'Build Success';
                tooltipString += 'GCM Status: ' + buildStatus + '\n';
            }
            if (!!platformBuildStatusJson.dV360BuildStatusId) {
                let buildStatus: string = platformBuildStatusJson.dV360BuildStatusId == eCampaignStatus.Build_Failed ? 'Build Failed' : 'Build Success';
                tooltipString += 'DV360 Status: ' + buildStatus + '\n';
            }
            if (!!platformBuildStatusJson.ttdBuildStatusId) {
                let buildStatus: string = platformBuildStatusJson.ttdBuildStatusId == eCampaignStatus.Build_Failed ? 'Build Failed' : 'Build Success';
                tooltipString += 'TTD Status: ' + buildStatus + '\n';
            }
            if (!!platformBuildStatusJson.gamBuildStatusId) {
                let buildStatus: string = platformBuildStatusJson.gamBuildStatusId == eCampaignStatus.Build_Failed ? 'Build Failed' : 'Build Success';
                tooltipString += 'GAM Status: ' + buildStatus + '\n';
            }
            if (!!platformBuildStatusJson.metaBuildStatusId) {
                let buildStatus: string = platformBuildStatusJson.metaBuildStatusId == eCampaignStatus.Build_Failed ? 'Build Failed' : 'Build Success';
                tooltipString += 'META Status: ' + buildStatus + '\n';
            }
            return tooltipString;
        }
        else
        {
            let tooltipString = '';
            if(!!platformBuildStatusJson.gcmBuildStatusId){
                tooltipString += 'GCM Status: Build Success\n';
            }
            if(!!platformBuildStatusJson.dV360BuildStatusId){
                tooltipString += 'DV360 Status: Build Success\n';
            }
            if(!!platformBuildStatusJson.ttdBuildStatusId){
                tooltipString += 'TTD Status: Build Success\n';
            }
            if(!!platformBuildStatusJson.gamBuildStatusId){
                tooltipString += 'GAM Status: Build Success\n';
            }
            if(!!platformBuildStatusJson.metaBuildStatusId){
                tooltipString += 'META Status: Build Success\n';
            }
            return tooltipString;
        }
    }

    campaignStatusIcon(statusId: eCampaignStatus){
        if(statusId == eCampaignStatus.Build_Success)
            return {'label': 'faCircleCheck','key': this.faCircleCheck};
        else if(statusId == eCampaignStatus.Build_Failed)
            return {'label': 'faCircleXmark','key': this.faCircleXmark};
        else if (statusId == eCampaignStatus.Build_Partial_Success)
            return {'label': 'faCircleExclamation','key': this.faCircleExclamation};
        else
            return null;
    }
    
    // isSendToApiVisibleHSAndHMP(rowData: IBaseCampaignDto){
    //     return (this.currentUser.userRole == eUserRole.Media_Activation || this.currentUser.userRole == eUserRole.Admin)
    //     && ((rowData.campaignType == eAccountType.HS && (rowData.campaignStatusId == eCampaignStatus.Assets_Approved || rowData.statusId == eCampaignStatus.Assets_Approved))
    //         || (rowData.campaignType == eAccountType.HMP && rowData.campaignStatusId == eCampaignStatus.Assets_Approved && rowData.statusId != eCampaignStatus.Build_Success));
    // }

    metaBuildParameterOutput(errorMessages : any, rowData: IBaseCampaignDto){
        errorMessages.push({
            message: "META Build Parameters"
        });
        errorMessages.push({message: `Ad Account Id: ${rowData.metaSettingsJson.adAccountId != null && rowData.metaSettingsJson.adAccountId != '' ? rowData.metaSettingsJson.adAccountId : '-'}` });
        errorMessages.push({message: `Ad Account Name: ${rowData.metaSettingsJson.adAccountName != null && rowData.metaSettingsJson.adAccountName != '' ? rowData.metaSettingsJson.adAccountName : '-'}` });
        errorMessages.push({message: `Facebook Page Id: ${rowData.facebookPageId != null ? rowData.facebookPageId : (rowData.account.metaPageId != null ? rowData.account.metaPageId : '-')}` });
        errorMessages.push({message: `Buying Type: ${rowData.metaSettingsJson.buyingType == '1' ? 'Auction': 'none'}` });
        errorMessages.push({message: `Campaign Objective: ${eCampaignObjectiveTypeMetaName.get(rowData.metaSettingsJson.campaignObjective)?.name}` });
        errorMessages.push({message: `Performance Goal: ${ePerformanceGoalTypeMetaName.get(rowData.metaSettingsJson.performanceGoal)?.name}` });
        errorMessages.push({message: `Bid Strategy: ${rowData.metaSettingsJson.bidStrategy== '1' ? 'Highest volume or value': 'Bid Cap'}` });
        if(rowData.campaignType == eAccountType.HMP){
            errorMessages.push({message: `Meta Dataset Pixel ID: ${rowData.metaSettingsJson.metaDatasetPixelId != null ? rowData.metaSettingsJson.metaDatasetPixelId : '-'}` });
            let rtCustomeAudiencesInclude = rowData.metaSettingsJson?.rtCustomeAudiencesInclude?.length ? rowData.metaSettingsJson.rtCustomeAudiencesInclude.map(a => a.name).join(', '): '-';
            let rtCustomeAudiencesExclude = rowData.metaSettingsJson?.rtCustomeAudiencesExclude?.length ? rowData.metaSettingsJson.rtCustomeAudiencesExclude.map(a => a.name).join(', '): '-';
            let lalCustomeAudiencesInclude = rowData.metaSettingsJson?.lalCustomeAudiencesInclude?.length ? rowData.metaSettingsJson.lalCustomeAudiencesInclude.map(a => a.name).join(', '): '-';
            let lalCustomeAudiencesExclude = rowData.metaSettingsJson?.lalCustomeAudiencesExclude?.length ? rowData.metaSettingsJson.lalCustomeAudiencesExclude.map(a => a.name).join(', '): '-';
            errorMessages.push({message: `RT Custom Audience Include: ${rtCustomeAudiencesInclude}` });
            errorMessages.push({message: `RT Custom Audience Exclude: ${rtCustomeAudiencesExclude}` });
            errorMessages.push({message: `LAL Custom Audience Include: ${lalCustomeAudiencesInclude}` });
            errorMessages.push({message: `LAL Custom Audience Exclude: ${lalCustomeAudiencesExclude}` });
        }
    }
    //Method to show campaign status message.
    campaignStatusMessage(rowData: IBaseCampaignDto){
        let platformBuildStatusJson: IPlatformBuildStatusJson = rowData.platformBuildStatusJson;
        let errorMessages = [];
        if(platformBuildStatusJson != null){
            let dv360ErrorMessages = rowData.campaignErrorMessages
                .filter(x => x.buildErrorType === eBuildErrorType.DV360BuildCampaign)
                .sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime())[0];
            let reinitiateMessage = "";
            let ttdErrorMessages = rowData.campaignErrorMessages
                .filter(x => x.buildErrorType === eBuildErrorType.TTDBuildCampaign)
                .sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime())[0];
            if (
                rowData.statusId === eCampaignStatus.Build_Partial_Success &&
                ((platformBuildStatusJson.dV360BuildStatusId === eCampaignStatus.Build_Failed &&
                dv360ErrorMessages?.message &&
                (
                    dv360ErrorMessages.message.includes("Syncing creatives from GCM still in progress") ||
                    dv360ErrorMessages.message.includes("HttpStatusCode is InternalServerError. Internal error encountered")
                )) || (platformBuildStatusJson.ttdBuildStatusId === eCampaignStatus.Build_Failed && ttdErrorMessages?.message &&
                    ttdErrorMessages.message.includes("An internal service error has occurred")
                ))
            ) {
                reinitiateMessage = "! HUB will attempt to rebuild the campaign automatically every 3 hours.";
            }

            //GCM
            if (platformBuildStatusJson.gcmBuildStatusId === eCampaignStatus.Build_Failed) {
                errorMessages.push({
                    message: "GCM Build: Build Failed"
                });
                const errorMessage = rowData.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.GCMBuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }
            else if (platformBuildStatusJson.gcmBuildStatusId === eCampaignStatus.Build_Success) {
                errorMessages.push({
                    message: "GCM Build: Build Success"
                });
            }

            //DV360
            if (platformBuildStatusJson.dV360BuildStatusId === eCampaignStatus.Build_Failed) {
                errorMessages.push({
                    message: "DV360 Build: Build Failed"
                });
                const errorMessage = rowData.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.DV360BuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }
            else if (platformBuildStatusJson.dV360BuildStatusId === eCampaignStatus.Build_Success) {
                errorMessages.push({
                    message: "DV360 Build: Build Success"
                });
                const errorMessage = rowData.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.DV360BuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }

            //TTD
            if (platformBuildStatusJson.ttdBuildStatusId === eCampaignStatus.Build_Failed) {
                errorMessages.push({
                    message: "TTD Build: Build Failed"
                });
                const errorMessage = rowData.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.TTDBuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }
            else if (platformBuildStatusJson.ttdBuildStatusId === eCampaignStatus.Build_Success) {
                errorMessages.push({
                    message: "TTD Build: Build Success"
                });
            }

            //GAM
            if (platformBuildStatusJson.gamBuildStatusId === eCampaignStatus.Build_Failed) {
                errorMessages.push({
                    message: "GAM Build: Build Failed"
                });
                const errorMessage = rowData.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.GAMBuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }
            else if (platformBuildStatusJson.gamBuildStatusId == eCampaignStatus.Build_Success) {
                errorMessages.push({
                    message: "GAM Build: Build Success"
                });
                const errorMessage = rowData.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.GAMBuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }

            //Meta
            if (platformBuildStatusJson.metaBuildStatusId === eCampaignStatus.Build_Failed) {
                this.metaBuildParameterOutput(errorMessages, rowData);

                errorMessages.push({
                    message: "META Build: Build Failed"
                });
                errorMessages.push(rowData.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.METABuildCampaign));
            }
            else if (platformBuildStatusJson.metaBuildStatusId === eCampaignStatus.Build_Success) {
                this.metaBuildParameterOutput(errorMessages, rowData);
                
                errorMessages.push({
                    message: "META Build: Build Success"
                });
            }
            this.confirmationService.confirm({
                header: 'Campaign Build Messages',
                key: 'campaignErrorMessage',
                message: `
                <div class="rebuild-message">${reinitiateMessage}</div>
                <div class="Dv360-warning-message ${reinitiateMessage ? '' : 'dv360-only'}">
                    ${(rowData.campaignType == eAccountType.FAN365 && platformBuildStatusJson.dV360BuildStatusId != null)
                        ? 'DV360 requires the Creative Type to be set manually. Open this campaign in DV360 and set it under Campaign Settings before it can serve.'
                        : ''}
                </div>
                <ul style="padding-left: 1px;">
                    ${errorMessages
                            .map((error, index) => {
                                return error.message.split(';')
                                    .map((line) => {
                                        let formattedLine = line.trim();
                                        if (formattedLine.includes('Build Failed') || formattedLine.includes('Build Success')) {
                                            return `${((formattedLine.includes('Build Failed') || formattedLine.includes('Build Success')) && index > 0) ? '<br>' : ''}<strong class="custom-list">${formattedLine}</strong>${(formattedLine.includes('Build Success')) ? '<br>' : ''}`;
                                        }
                                        if(formattedLine.includes('META Build Parameters')){
                                            return `<br><strong class="custom-list">${formattedLine}</strong>`;
                                        }
                                        return `<li class="custom-list-item">${formattedLine}</li>`;
                                    })
                                    .join('');
                            })
                            .join('')}
                </ul>
                `,
                rejectVisible: false,
                acceptVisible: false,
                rejectLabel: 'Close',
                reject: () => {
                    this.confirmationService.close();
                }
            });
        }
        
    }

    async autoBuildGAMCampaign(baseCampaignId: string, isCampaignBuildTriggeredFromUI: boolean, campaignType: eAccountType, campaignName: string,isAutomaticCampaignBuild: boolean, campaignJSON: string,platformBuildStatusJson: IPlatformBuildStatusJson) {
        
        //Check if campaign build is already outside of HUB
        if (campaignJSON != null && platformBuildStatusJson == null) {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Campaign has been already built outside of the HUB. You can’t send this campaign to API build.', life: 5000 });
            return;
        }

        this.confirmationService.confirm({
            header: 'Confirmation',
            key: 'changeStatus',
            message:
                'This action will initiate campaign API build. Do you want to continue?',
            rejectVisible: true,
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            acceptButtonStyleClass: 'edge-button',
            rejectButtonStyleClass: 'edge-no-button',
            accept: async () => {
                return new Promise<string>((resolve, reject) => {
                    this.campaignController.AutoBuildGAMCampaign(baseCampaignId, isCampaignBuildTriggeredFromUI,campaignType,campaignName,isAutomaticCampaignBuild).subscribe(
                        (val: string[] | any) => {
                            if (Array.isArray(val) && val != null) {
                                let GCMResponse = JSON.parse(val[0]);
                                let GAMResponse = JSON.parse(val[1]);
                                resolve('GCM: ' + GCMResponse.join('\n') + '\nGAM: ' + GAMResponse.join('\n'));
                            } else {
                                resolve('Internal Server Error, please contact your administrator.');
                            }
                        },
                        (error: any) => {
                            reject(error.message);
                        }
                    );
                });
            }
        });
    }
    getProductCategoryLabel(inventoryItem: ICampaignInventoryItemDto): string {
        if(!!inventoryItem){
            if(!!inventoryItem.inventoryItemNew){
                switch(inventoryItem.inventoryItemNew.productCategory){
                    case eProductCategoryFan365.CTV_OTT:
                        return 'CTV/OTT';
                    case eProductCategoryFan365.Display_Banner:
                        return 'Display Banner';
                    case eProductCategoryFan365.In_Stream_Video:
                        return 'In-Stream Video';
                    case eProductCategoryFan365.Social:
                        return this.gridId == 6 ? 'Social (Fan365)' : 'Social';
                    case eProductCategoryFan365.Audio:
                        return 'Audio';
                    case eProductCategoryFan365.Display_Social_Bundle:
                        return 'Display + Social Bundle';
                    case eProductCategoryFan365.NIL_Display_Banner:
                        return 'NIL Display Banner';
                    default:
                        return '-';
                }
            }
            else if(!!inventoryItem.inventoryItemOAS){
                switch(inventoryItem.inventoryItemOAS.productCategory){
                    case eProductCategoryOAS.Fall_Premium_Takeover_Super_Billboard:
                        return 'Fall Premium Takeover - Super Billboard';
                    case eProductCategoryOAS.Fall_Premium_Takeover_Wallpaper:
                        return 'Fall Premium Takeover - Wallpaper';
                    case eProductCategoryOAS.OAS_App_Logo_Entitlement:
                        return 'OAS - App Logo Entitlement';
                    case eProductCategoryOAS.OAS_Fall_SOV:
                        return 'OAS - Fall SOV';
                    case eProductCategoryOAS.OAS_Run_Of_App_Display_Ad:
                        return 'OAS - Run of App Display Ad';
                    case eProductCategoryOAS.OAS_Run_Of_App_Interstitial_Ad:
                        return 'OAS - Run of App Interstitial Ad';
                    case eProductCategoryOAS.OAS_Run_Of_Site_Display_Ad:
                        return 'OAS - Run of Site Display Ad';
                    case eProductCategoryOAS.OAS_Run_Of_Site_Display_Ad_TO:
                        return 'OAS - Run of Site Display Ad TO';
                    case eProductCategoryOAS.OAS_Spring_Summer_SOV:
                        return 'OAS - Spring/Summer SOV';
                    case eProductCategoryOAS.OAS_Standard_Page_Takeover:
                        return 'OAS - Standard Page Takeover';
                    case eProductCategoryOAS.OAS_Video_Ad:
                        return 'OAS - Video Ad';
                    case eProductCategoryOAS.OAS_Winter_SOV:
                        return 'OAS - Winter SOV';
                    case eProductCategoryOAS.Spring_Summer_Premium_Takeover_Super_Billboard:
                        return 'Spring/Summer Premium Takeover - Super Billboard';
                    case eProductCategoryOAS.Spring_Summer_Premium_Takeover_Wallpaper:
                        return 'Spring/Summer Premium Takeover - Wallpaper';
                    case eProductCategoryOAS.Winter_Premium_Takeover_Super_Billboard:
                        return 'Winter Premium Takeover - Super Billboard';
                    case eProductCategoryOAS.Winter_Premium_Takeover_Wallpaper:
                        return 'Winter Premium Takeover - Wallpaper';
                   case eProductCategoryOAS.Page_Sponsorship:
                        return 'Page Sponsorship';
                        case eProductCategoryOAS.Page_Banner_Ad:
                        return 'Page Banner Ad';
                    case eProductCategoryOAS.Premium_Take_Over:
                        return 'Premium Take Over';
                    case eProductCategoryOAS.Clips_Sponsorship:
                        return 'Clips Sponsorship';
                    case eProductCategoryOAS.Clips_Sponsorship:
                        return 'Clips Sponsorship';
                    case eProductCategoryOAS.Entitlements:
                        return 'Entitlements';
                    case eProductCategoryOAS.Mobile:
                        return 'Mobile'; 
                    case eProductCategoryOAS.Logo:
                        return 'Logo';                  
                    default:
                        return '-';
                }
            }
            else if(!!inventoryItem.inventoryItemSocial){
                switch(inventoryItem.inventoryItemSocial.productCategory){
                    case eProductCategorySocial.Social:
                        return 'Social';
                    case eProductCategorySocial.Content:
                        return 'Content (Social)';
                    default:
                        return '-';
                }
            }
            else if(!!inventoryItem.inventoryItemContent){
                switch(inventoryItem.inventoryItemContent.productCategory){
                    case eProductCategoryContent.Content:
                        return 'Content';
                    default:
                        return '-';
                }
            }
        }
    }

    //Method to check if channel is ready for build based on creatives status and creative assets validation.
    isChannelReadyForBuild(creatives: ICreativeDto[], creativeTypeIds: number[], platformBuildStatusJson: IPlatformBuildStatusJson, buildProcess: string): boolean {
        const relevantCreatives = creatives.filter(c =>
            creativeTypeIds.includes(c.creativeTypeId) &&
            c.entityStatus === eEntityStatus.Active &&
            c.creativeStatusId == eCreativeStatus.Submitted
        );

        if (relevantCreatives.length === 0) return false;

       const isBuilt =
            buildProcess === "META"
                ? platformBuildStatusJson?.metaBuildStatusId === eCampaignStatus.Build_Success
                : buildProcess === "DV360" || buildProcess === "TTD"
                    ? platformBuildStatusJson?.gcmBuildStatusId === eCampaignStatus.Build_Success &&
                    platformBuildStatusJson?.dV360BuildStatusId === eCampaignStatus.Build_Success &&
                    platformBuildStatusJson?.ttdBuildStatusId === eCampaignStatus.Build_Success
                    : false;
        var res = relevantCreatives.some(c => {
            const hasValidAssets =
                c.creativeAssets.some(ca => ca.file) &&
                c.creativeAssets.filter(a => !!a.file).every(a => a.isValid === true);

            if (!hasValidAssets) return false;
                
            return !isBuilt || c.creativeStatusBuildId === eCreativeStatusBuild.Notset;
        });
        return res;

    }

    //Method to get the campaign date line string based on start and end dates.
    getCampaignDateLine(startDateValue: Date | string, endDateValue: Date | string): string {
        const startDate = startDateValue && moment(startDateValue).isValid()
            ? moment(startDateValue).format('MM/DD/YY')
            : null;

        const endDate = endDateValue && moment(endDateValue).isValid()
            ? moment(endDateValue).format('MM/DD/YY')
            : null;

        const notSetHtml = '<span class="not-set-text">Not set</span>';

        if (!startDate && !endDate) {
            return notSetHtml;
        }

        if (!startDate) {
            return `${notSetHtml} - ${endDate}`;
        }

        if (!endDate) {
            return `${startDate} - ${notSetHtml}`;
        }

        return `${startDate} - ${endDate}`;
    }


    getApiBuildMenuTooltip(rowData: IBaseCampaignDto, apiHSBuildChannels: eStandardCampaginChannel[]): string {
        const apiBuildChannels = [
            eStandardCampaginChannel.Standard_Display_Banner,
            eStandardCampaginChannel.Abandoned_Cart_Display_Banner,
            eStandardCampaginChannel.Post_Purchase_Upsell_Display_Banner,
            eStandardCampaginChannel.Native_Image,
            eStandardCampaginChannel.Native_Video,
            eStandardCampaginChannel.ConnectedTv,
            eStandardCampaginChannel.In_Stream_Video
            // eStandardCampaginChannel.Streaming_Audio
        ];
        
        const isDisabledHsApiAction =
            rowData.campaignType == eAccountType.HS && !((rowData.campaignStatusId == this.enumCampaignStatus.Assets_Approved || rowData.statusId == this.enumCampaignStatus.Assets_Approved) 
                && rowData.statusId != this.enumCampaignStatus.Sent_to_API_Build
                && (this.isChannelReadyForBuild(rowData.creatives, apiHSBuildChannels, rowData.platformBuildStatusJson,"TTD") || this.isChannelReadyForBuild(rowData.creatives, apiHSBuildChannels, rowData.platformBuildStatusJson,"DV360")));

        if (!isDisabledHsApiAction) {
            return null;
        }

        const blockedCreatives = rowData.creatives.filter(creative => {
            // Only consider API build inventory types
            if (apiBuildChannels.includes(creative.creativeTypeId)) {
                const hasValidAssets =
                    creative.creativeAssets.some(asset => asset.file) &&
                    creative.creativeAssets
                        .filter(asset => !!asset.file)
                        .every(asset => asset.isValid);

                return creative.creativeStatusId !== eCreativeStatus.Submitted || !hasValidAssets;
            }
        });

        if (!blockedCreatives.length) {
            return 'All flights are approved for sending to API.';
        }

        const blockedByChannel: Record<string, string[]> = {};

        blockedCreatives.forEach(creative => {

            const channel = eChannelType[creative.channelId];

            const flight = eStandardCampaginChannelName.get(creative?.creativeTypeId)?.name;

            if (!blockedByChannel[channel]) {
                blockedByChannel[channel] = [];
            }

            if (!blockedByChannel[channel].includes(flight)) {
                blockedByChannel[channel].push(flight);
            }
        });

        const channelNames = Object.keys(blockedByChannel).sort();

        const lines: string[] = [];

        channelNames.forEach(channel => {

            lines.push(`Channel: ${channel}`);

            blockedByChannel[channel]
                .sort()
                .forEach(flight => {
                    lines.push(`Flight: ${flight}`);
                });

            lines.push('');
        });

        const formatChannelList = (channels: string[]): string => {
            if (channels.length === 1) {
                return channels[0];
            }

            if (channels.length === 2) {
                return `${channels[0]} and ${channels[1]}`;
            }

            return `${channels.slice(0, -1).join(', ')} and ${channels[channels.length - 1]}`;
        };

        const summary = `All ${formatChannelList(channelNames)} flights are not approved for sending to API.`;

        lines.push(summary);

        return lines.join('\n');
    }

    isHSChannel(creatives: ICreativeDto[], apiBuildChannels: eStandardCampaginChannel[]): boolean {
        return creatives.some(creative =>
            apiBuildChannels.includes(creative.creativeTypeId)
        );
    }

    // Show a warning dialog for creative type issues
    showCreativeTypeWarningDialog(): void {
        this.confirmationService.confirm({
            header: 'Action Required in DV360',
            key: 'creativeTypeWarning',
            message: `
                <div class="creative-type-warning-message">
                    DV360 requires the Creative Type to be set manually. Open this campaign in DV360 and set it under Campaign Settings before it can serve.
                </div>
            `,
            acceptVisible: false,
            rejectVisible: false
        });

        this.DV360creativeCheckBoxWarningTimeout = setTimeout(() => {
            this.confirmationService.close();
        }, 5000);
    }

}
